import React, { useState, useEffect } from 'react';

import RupeeIcon from '../../../icons/Rupee';
import ArrowUp from '../../../icons/ArrowUp';
import ArrowDown from '../../../icons/ArrowDown';
import DiscountIcon from '../../../../../commonstories/src/icons/Discount';

import FareOptions from '../FareFamily/fare-family';
import FlightInfo from '../flight-info-details/flight-info-details';
import PriceLockTag from '../PriceLockTag/price-lock-tag';
import PriceLock from '../PriceLockListing/price-lock-listing';
import WhitelockIcon from '../../../icons/WhiteLockIcon';

import Route from './route';
import * as S from './srp-card-ui.styles';
import formatPrice from '@ibibo/format-price';

// const getEMIPriceInStr = flightItem => {
//   const price = flightItem.valuesForSort.cost;
//   const emiPrice = Math.ceil(price / 3);
//   return emiPrice.toLocaleString('en-IN');
// };

const FlightCardTags = ({ isCheapest, flightItem, hasPriceLockFare, priceLockDetails }) => {
  return (
    <>
      {isCheapest && (
        <S.PromoTag>
          <span className="cheapest dF alignItemsCenter">
            <span>Cheapest</span>
          </span>
        </S.PromoTag>
      )}
      {!isCheapest && !flightItem.isExtraSeatFlight && (
        <S.PromoTag>
          <span>&nbsp;</span>
        </S.PromoTag>
      )}
      {hasPriceLockFare ? (
        <>
          {/* <S.PromoTag>
              <span className="dateChange dF"> Free Date Change &nbsp;&nbsp;</span>
            </S.PromoTag> */}
          <S.PromoTag>
            <span className="farelock dF">
              <WhitelockIcon width="1rem" height="1rem" />
              <span>{`Lock price at ₹${priceLockDetails.f} for ${priceLockDetails.v} days`}</span>
            </span>
          </S.PromoTag>
        </>
      ) : null}
    </>
  );
};

const SeoSrpCardUi = props => {
  const {
    flightItem,
    handleFlightSelection, // For Book Button
    isFlightSelected,
    airports, // For Flight Details
    commonRulesData,
    callCommonRulesAPI,
    isDomesticRoundTrip,
    logPDT,
    pushGAEvents,
    typeOfTravel,
    messageValues,
    getPriceLockInfoHtml,
    setLockPrice,
    isLoggedIn,
    onwardMinPrice,
    staticInformation,
    list,
    showFareFamilyPersuasionText = false
  } = props;
  const {
    priceToDisplay,
    slashedFare,
    offerInfo,
    discountedFare,
    discount,
    disMessage,
    flightArr,
    multiCheckingText
  } = flightItem;

  const price = discountedFare ? discountedFare : priceToDisplay;
  const isCheapest =
    price && parseInt(price.replace(',', ''), 10) === onwardMinPrice ? true : false;
  // const isMulti = flightItem?.valuesForSort?.carrier === 'multi';
  const isIntl = typeOfTravel && typeOfTravel.includes('international') ? true : false;
  const hasLayover = flightArr && flightArr.length > 1 ? true : false;

  const [deals, setShowDeals] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowDeals(false);
    }, 2000);
    if (flightItem.discountApply === 3) {
      logPDT({ action_name: 'stealdeal_shown_srp' });
    }
  }, []);

  const getVisaRequired = flightArr => {
    let visaRequired = false;
    flightArr &&
      flightArr.map(f => {
        if (f.visaRequired === true) {
          visaRequired = true;
          return;
        }
      });
    return visaRequired;
  };

  const visaRequired = getVisaRequired(flightArr);

  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    if (!isFlightSelected && showSpinner) {
      setShowSpinner(false);
    }
  }, [isFlightSelected]);

  const handleBookClick = () => {
    if (!showSpinner) {
      setShowSpinner(true);
      handleFlightSelection(flightItem);
    }
  };

  const handleFaresBookClick = anc_index => {
    const flightItemSelected = {
      ...flightItem,
      bundleIndex: anc_index,
      anc_index
    };
    handleFlightSelection(flightItemSelected);
  };

  const handleLockClick = () => {
    if (!isLoggedIn) {
      logPDT({ action_name: 'pricelock_signin' });
      window.GI.HeaderEvent.trigger('START_LOGIN_FLOW');
    } else {
      setLockPrice(true);
      handleBookClick();
    }
  };

  const handleFaresLockClick = anc_index => {
    if (!isLoggedIn) {
      logPDT({ action_name: 'pricelock_signin' });
      window.GI.HeaderEvent.trigger('START_LOGIN_FLOW');
    } else {
      setLockPrice(true);
      handleFaresBookClick(anc_index);
    }
  };

  const getLayoverText = flights => {
    const hasOfferText = !isAlternateFlight && offerInfo?.showOffer ? true : false;
    const flightsSlicedArray = !hasOfferText ? flights.slice(1) : flights.slice(1, 4);
    const carrierNameText = `${flightsSlicedArray
      .map(f => `${f.depText} ${f.layoverInfo}`)
      .join(', ')}`;
    return `Layover${flights.length > 2 ? 's' : ''} - ${carrierNameText}${
      hasOfferText && flights.length > 4 ? '...' : ''
    }`;
  };

  const isAlternateFlight = flightItem && flightItem?.alternateText;
  const hasPriceLockFare = flightItem && flightItem.priceLockFareDetails ? true : false;
  const priceLockDetails = hasPriceLockFare ? flightItem?.priceLockFareDetails : null;
  const hasMultipleFares = !!flightItem.ancillaryList && !isAlternateFlight;

  const [isExpanded, setIsExpanded] = useState(false);
  const [showMultipleFares, setShowMultipleFares] = useState(false);

  const ViewFareClickHandler = () => {
    if (logPDT) {
      logPDT({ action_name: showMultipleFares ? 'hide_fare_clicked' : 'view_prices_clicked' });
    }
    if (pushGAEvents) {
      pushGAEvents('see_fares', 'flexi', !showMultipleFares, '');
    }
    setShowMultipleFares(!showMultipleFares);
  };

  const FlightDetailsClickHandler = () => {
    if (pushGAEvents) {
      pushGAEvents(
        'fltViewDetails_' + typeOfTravel.toLowerCase(),
        isExpanded ? 'collapse' : 'expand',
        '',
        ''
      );
    }
    setIsExpanded(!isExpanded);
  };

  const dailyStealDealsClicked = () => {
    logPDT({ action_name: 'stealdeal_srp_click' });
  };

  return (
    <S.SeoCard className="" isDomesticRoundTrip={isDomesticRoundTrip}>
      <div className="dF justifyEnd">
        {isAlternateFlight ? (
          <div className="dF justifyBetween width100 marginB10">
            <S.AlternateText>
              <span className="fb">{flightItem.alternateText}</span>
            </S.AlternateText>
            <S.AlternateSaveText>
              <span className="fb">
                You save ₹{flightItem.alternateSavings.toLocaleString('en-IN')}
              </span>
            </S.AlternateSaveText>
          </div>
        ) : null}
        {/* {(hasMultipleFares || flightItem.isExtraSeatFlight) && !hasPriceLockFare ? (
          <S.FareFamilyHeaderWrapper>
            <S.FareFamilyHeader>
              <span>
                {flightItem.isExtraSeatFlight
                  ? `${flightItem.extraSeatType === 7 ? '+1' : '+2'} Extra Seat`
                  : 'Fare Options Available'}
              </span>
            </S.FareFamilyHeader>
          </S.FareFamilyHeaderWrapper>
        ) : null} */}
        {flightItem?.isExtraSeatFlight && !hasPriceLockFare ? (
          <S.FareFamilyHeaderWrapper>
            <S.FareFamilyHeader>
              <span className="fb">
                {`${flightItem?.extraSeatType === 7 ? '+1' : '+2'} Extra Seat`}
              </span>
            </S.FareFamilyHeader>
          </S.FareFamilyHeaderWrapper>
        ) : null}
        {/* {!isIntl &&
          !hasPriceLockFare &&
          !isCheapest &&
          !flightItem.isExtraSeatFlight &&
          !isAlternateFlight && (
            <S.PromoTag>
              <span className="dateChange dF"> Free Date Change</span>
            </S.PromoTag>
          )} */}
        {/* {props.extraSeat && (
        <S.PromoTag>
          <span className="extraSeat dF alignItemsCenter">
            <S.ExtraSeatIco /> <S.ExtraSeatIco />
            <S.ExtraSeatIco />
            <span className="padT2">Full Row</span>
          </span>
        </S.PromoTag>
      )} */}
        {/* {isIntl && !hasPriceLockFare && !isCheapest && (
          <S.PromoTag>
            <span className="eticketTime dF alignItemsCenter">
              <DiscountIcon width="1rem" height="1rem" />
              <span className="padL5">E-ticket will be sent after 24 hrs of booking</span>
            </span>
          </S.PromoTag>
        )} */}
        <FlightCardTags
          isCheapest={isCheapest}
          flightItem={flightItem}
          hasPriceLockFare={hasPriceLockFare}
          priceLockDetails={priceLockDetails}
        />
      </div>
      <S.CardWrap className="width100 dF">
        <S.CardLeft>
          <Route flightItem={flightItem} />
          {flightItem.returnFlight ? <S.BrdrBtmDash className="marginT10 marginB10" /> : null}
          {flightItem.returnFlight ? <Route flightItem={flightItem.returnFlight} /> : null}
        </S.CardLeft>
        <S.CardRight className="dF justifyEnd">
          <S.PriceWrap
            className={`flexCol padB10 ${
              isIntl && flightItem.returnFlight ? 'justifyCenter' : 'justifyEnd'
            }`}
          >
            {discount ? (
              <S.DiscountWrap className="fmtTooltip">
                <i className="icon-offer-badge yellow ico20 padR5"></i>
                <i className="icon-rupee ico8"></i>
                <span className="ico12 fb padR3">{discount}</span>
                <i className="icon-arrow-right ico8"></i>
                <div className="tip tip_btm white ">
                  <div className="fb black">{disMessage}</div>
                </div>
              </S.DiscountWrap>
            ) : null}
            <div className="alignItemsEnd flexCol">
              {slashedFare ? (
                <S.SlashedFare className="strike alignItemsCenter grey dF ico13">
                  {formatPrice(slashedFare)}
                </S.SlashedFare>
              ) : (
                <span className="alignItemsCenter dF ico13 padB5">
                  <span>&nbsp;</span>
                </span>
              )}
              <S.Price className="alignItemsCenter dF fb lh1 padT5">
                <RupeeIcon fill="#141823" loading="lazy" />
                {discountedFare ? discountedFare : priceToDisplay}
              </S.Price>
              {/* <S.FlysmartText>&nbsp;</S.FlysmartText> */}
              {/* {!discountedFare ? (
                <S.Emi className="padT5 padB10 font12 black">
                  <span>No Cost EMI from </span>
                  <span className="fb">
                    <RupeeIcon fill="#141823" width="1rem" height="1rem" />
                    {getEMIPriceInStr(flightItem)}
                  </span>
                </S.Emi>
              ) : null} */}
            </div>
            {/* <div className="font11 padT5 padB10 grey">&nbsp;</div> */}
          </S.PriceWrap>
          <S.BookWrap className="justifyCenter flexCol alignItemsEnd padB5">
            <S.BookBtWrap className="flexCol width100">
              {(hasPriceLockFare && (
                <PriceLock
                  details={priceLockDetails}
                  fare={discountedFare ? discountedFare : priceToDisplay}
                  messageValues={messageValues}
                  bookPriceLock={handleLockClick}
                  getPriceLockInfoHtml={getPriceLockInfoHtml}
                  isLoggedIn={isLoggedIn}
                  logPDT={logPDT}
                  hasMultipleFares={hasMultipleFares}
                />
              )) || <S.LockButtonPlaceholder>&nbsp;</S.LockButtonPlaceholder>}
              <S.BookButton
                className="dF justifyCenter alignItemsCenter txtUpper"
                onClick={hasMultipleFares ? ViewFareClickHandler : handleBookClick}
              >
                {!showSpinner ? (
                  <>
                    {hasMultipleFares ? (showMultipleFares ? 'HIDE FARE' : 'VIEW FARES') : 'BOOK'}
                  </>
                ) : (
                  <S.Spinner></S.Spinner>
                )}
              </S.BookButton>
            </S.BookBtWrap>
            {/* <div className="font11 padT5 padB10 grey">&nbsp;</div> */}
          </S.BookWrap>
        </S.CardRight>
      </S.CardWrap>
      <div className="dF justifyBetween width100 padLR20">
        <S.LayoverOfferWrap className="dF justifyBetween ">
          {hasLayover ? (
            <div className="font12 grey">{getLayoverText(flightArr)}</div>
          ) : (
            <div className="font12 grey">&nbsp;</div>
          )}
          {!isAlternateFlight && offerInfo?.showOffer ? (
            <S.FlySmart
              className={'font11 dF alignItemsCenter ' + (deals && list === 1 ? 'showOnce' : '')}
            >
              <span className="padR3">
                <S.OfferText>{offerInfo.offerText}</S.OfferText>
              </span>
              {flightItem?.discountApply === 3 && staticInformation?.dsi ? (
                <>
                  <img
                    src={staticInformation?.dsi?.ti}
                    width="10"
                    height="14"
                    onClick={dailyStealDealsClicked}
                    alt="daily_steal_deals"
                  />
                  <div className="dailyStealDeal">
                    <p className="marginB4">
                      <img
                        src={staticInformation?.dsi?.sdi}
                        width="137"
                        height="11"
                        alt="daily_steal_deals_static_info"
                      />
                    </p>
                    <p className="dF alignItemsCenter">
                      <img
                        src={staticInformation?.dsi?.ti}
                        width="13"
                        height="18"
                        alt="daily_steal_deals_static_info_ti"
                      />
                      <span className="marginL3 fb">{staticInformation?.dsi?.tm}</span>
                    </p>
                  </div>
                </>
              ) : (
                <DiscountIcon width="1.5rem" height="1.5rem" />
              )}
            </S.FlySmart>
          ) : null}
        </S.LayoverOfferWrap>
      </div>
      <S.CardFooter className="dF width100 justifyBetween alignItemsEnd">
        <div className="dF font11 alignItemsCenter">
          {visaRequired && (
            <span className="dF grey alignItemsCenter padR10">
              <DiscountIcon width="1.5rem" height="1.5rem" />
              <span className="padL5"> Transit Visa required </span>
            </span>
          )}

          {multiCheckingText ? (
            <S.MultiBanner>
              <S.MultiBannerTag>{multiCheckingText}</S.MultiBannerTag>
              <div className="grey ico11 padL5">Baggage re-check will be required</div>
            </S.MultiBanner>
          ) : null}
          {/* {flightItem.refundability}{' '} */}
          {flightItem.footerText !== '' ? (
            <span className="padT5 grey padL5"> {flightItem.footerText}</span>
          ) : null}
        </div>
        <div className="" onClick={FlightDetailsClickHandler}>
          <a className="dF alignItemsCenter curPointFlt alignItemsCenter fr">
            <span className="hpyBlueLt padR5 fb font11">Flight Details</span>
            {isExpanded ? (
              <ArrowUp width="1rem" height="1rem" />
            ) : (
              <ArrowDown width="1rem" height="1rem" />
            )}
          </a>
        </div>
      </S.CardFooter>
      {isExpanded ? (
        <FlightInfo
          flightItem={flightItem}
          airports={airports}
          commonRulesData={commonRulesData}
          callCommonRulesAPI={callCommonRulesAPI}
          logPDT={logPDT}
          pushGAEvents={pushGAEvents}
          typeOfTravel={typeOfTravel}
        />
      ) : null}
      {hasMultipleFares && showMultipleFares ? (
        <FareOptions
          priceLockDetails={priceLockDetails}
          ancillaryList={flightItem.ancillaryList}
          onBookClickHandler={handleFaresBookClick}
          onLockClickHandler={handleFaresLockClick}
          messageValues={messageValues}
          getPriceLockInfoHtml={getPriceLockInfoHtml}
          isLoggedIn={isLoggedIn}
          logPDT={logPDT}
          showFareFamilyPersuasionText={showFareFamilyPersuasionText}
        />
      ) : null}
    </S.SeoCard>
  );
};

export default SeoSrpCardUi;
